// debugging slows down the interval and the number of rows to retrieve per call
const debug = false

// root domain; REACT_APP_DATA_URL points a test build at a local copy of the site
export const dataUrl = process.env.REACT_APP_DATA_URL || 'https://autoproef.nl/'

//  api url
export const apiUrl = dataUrl + 'api/'

// address visitors scan on the kiosk screen to follow the times on their phone
export const siteUrl = 'https://autoproef.nl'

// max rows to retrieve, for debugging only
export const maxRows = debug ? 30 : 0

// poll delay in ms; 5 seconds
export const pollDelayShort = 5 * 1000

// long poll delay is used when cached results are retrieved (a really long time)
export const pollDelayLong = 99 * 60 * 1000

// time notification is displayed
export const notificationTime = 30 * 1000

// maximum number of notifications displayed
export const notificationsMax = 3

